import {Component, ElementRef, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NgRedux, Select} from '@angular-redux3/store';
import {Observable} from 'rxjs';

import {ALogout, ASetPlayerId, ASetRemote, AUnsetRemote, PlaylistRemoteAppState, sseApi} from '../../store';
import {BusinessStatus, Remote} from '../../store/entities';
import {SyncDialogService} from '../../services/sync-dialog.service';
import {LocationStrategy} from '@angular/common';
import {Router} from '@angular/router';
import {HelpComponent} from './help/help.component';
import {MatDialog} from '@angular/material/dialog';
import {environment} from '../../../environments/environment';
import {SettingsDialogComponent} from '../../components/dialogs/settings-dialog/settings-dialog.component';
import {SyncSpinnerComponent} from '../sync-spinner/sync-spinner.component';

/**
 * TODO : This component requires a refactoring on the long run
 * html : view is containing dynamic css attributes values
 * ts is containing deprecated code
 * --> Advising to move to a Full Material Component with specific css
 */
@Component({
  selector: 'mwo-side-panel',
  templateUrl: './side-panel.component.html',
  styleUrls: ['./side-panel.component.scss']
})
export class SidePanelComponent implements OnInit, OnDestroy {
  loading = false;
  offline = false;

  constructor(
    private ngRedux: NgRedux<PlaylistRemoteAppState>,
    private syncDialogService: SyncDialogService, private _location: LocationStrategy, private _router: Router,
    public dialog: MatDialog,
  ) {
  }
  @ViewChild('sidePanel', { static: true, read: ElementRef }) sidePanel: ElementRef;
  @ViewChild('check') check: ElementRef<HTMLInputElement>;
  @Select('remotes') remotes$: Observable<Remote[]>;
  @Select(['player', 'businessStatus']) status$: Observable<BusinessStatus>;
  private _prevOnSameUrlNavigation;
  public _showMenu = true;
  private _helpDialog: any;
  private _syncSpinnerDialog: any;
  private syncSpinnerDialogOpened = false;

  protected readonly environment = environment;
  settings = false;
  help = false;
  extendedMenu = false;

  ngOnInit() {
    this._prevOnSameUrlNavigation = this._router.onSameUrlNavigation;
    this._router.onSameUrlNavigation = 'ignore';
    this._location.pushState('Modal state', 'Modal title', this._router.url, '');

    this.status$.subscribe((status) => {
      if (!status) {
        return;
      }
      if (status?.downloadStatus?.type !== 'FINISHED'
        || (status?.syncStatus?.type !== 'FINISHED' && status?.syncStatus?.type !== 'OFFLINE')) {
        this.loading = true;
        this.openSyncSpinnerDialog();
        if (status?.syncStatus?.type === 'OFFLINE') {
          this.offline = true;
        }
      } else {
        if (this.loading) {
          this.ngRedux.dispatch(ASetRemote(this.ngRedux.getState().remotes[0]));
          this._router.navigate(['/']);
        }
        this.loading = false;
      }
    });
  }

  onChangePlayer(remote: Remote) {
    console.debug('onChangePlayer', remote);
    sseApi.close();
    this.ngRedux.dispatch(ASetPlayerId(remote));
    this.toggleSidePanel();
    this._router.navigate(['/library']);
    this.syncDialogService.openSyncDialog();
  }


  @HostListener('window:popstate', ['$event'])
  public onPopState(event: any) {
    if (this._router.url === '/library') {
      this.toggleSidePanel();
    }
    event.preventDefault();
    event.stopPropagation();
    event.cancelBubble = true;
  }

  @HostListener('window:click', ['$event'])
  clickout(event) {
    if (this.sidePanel && this.check && !this.sidePanel.nativeElement.contains(event.target) && !this.popupOpened()) {
      this.check.nativeElement.checked = false;
    }
  }

  toggleSidePanel() {
    this._showMenu = !this.sidePanel.nativeElement.classList.toggle('active');
    this.ngRedux.dispatch(AUnsetRemote());
  }

  handleClickLogout() {
    this.ngRedux.dispatch(ALogout());
  }

  checkChanged(check) {
    this.extendedMenu = check.checked;
  }

  openHelp(): void {
    this.help = true;
    this._helpDialog = this.dialog.open(HelpComponent, {
      width: '302px',
      height: '23Opx',
    });
    this._helpDialog.afterClosed().subscribe(() => {
      this.help = false;
    });
  }

  openSyncSpinnerDialog(): void {
    if (!this.syncSpinnerDialogOpened) {
      this.syncSpinnerDialogOpened = true;
      this._syncSpinnerDialog = this.dialog.open(SyncSpinnerComponent, {
        disableClose: true,
        width: '370px',
        height: '350px'
      });
      this._syncSpinnerDialog.afterClosed().subscribe(() => {
        this.syncSpinnerDialogOpened = false;
      });
    }
  }

  public ngOnDestroy() {
    this._router.onSameUrlNavigation = this._prevOnSameUrlNavigation;
    if (this._helpDialog) {
      this._helpDialog.close();
    }
  }

  toggleSettings() {
    this.settings = true;
    const dialogRef = this.dialog.open(SettingsDialogComponent);

    dialogRef.afterClosed().subscribe(() => {
      this.settings = false;
    });
  }

  private popupOpened() {
    return this.settings || this.help;
  }

  openBlacklist() {
    this._router.navigate(['/blacklist']).then();
  }
}
